export default __webpack_public_path__ + "static/media/arequipa-monastery.8649f0b2.jpg";